import React from 'react';
import $ from "jquery";
import {Modal, Button} from 'react-bootstrap';

import {sendRequest} from './global.js';
import Storage, {T} from './Storage.js';

var SimpleRequestsView = React.createClass({
  getInitialState: function() {
    var state = {
      options: Storage.getConfig(this.props.configKey).options,
      config: Storage.getConfig(this.props.configKey).config,
      responseContent: false,
    };
    return state;
  },

  onRequest: function(e) {
    var key = $(e.currentTarget).attr("data-key");
    sendRequest({
      method: this.state.options[key].request,
      type: this.state.options[key].type,
      success: function(data) {
        this.setState({responseContent: data});
      }.bind(this),
      error: function(xhr, status, err) {
      }
    });
  },

  onModalClose: function() {
    this.setState({responseContent: false});
  },

  render: function() {
    var thisView = this;
    var buttons = Object.keys(this.state.options).map(function(key){
      var option = thisView.state.options[key];
      return (
        <button
          key={key} 
          data-key={key}
          className="btn btn-default button-request" 
          onClick={thisView.onRequest}
        >{option.title}</button>
      )
    });
    return (
      <div className="adminContent customScrollBar">
        <h1 className="page-header">
          {this.state.config.title}
        </h1>
        {buttons}

        <Modal show={!!this.state.responseContent} onHide={this.onModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>{T("modal_response_title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <span className="errorMessage">{this.state.responseContent.error}</span>
            {this.state.responseContent.message}
            <br/>
            <a href={this.state.responseContent.link} target="_blank">{this.state.responseContent.link ? T("modal_response_link") : ""}</a>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onModalClose}>{T("button_close")}</Button>
          </Modal.Footer>
        </Modal>

      </div>
    )
  },
});

export default SimpleRequestsView;



// WEBPACK FOOTER //
// ./src/SimpleRequestsView.js